import { render, staticRenderFns } from "./TurkeyDeveloped.vue?vue&type=template&id=6006b5a0&lang=pug&"
import script from "./TurkeyDeveloped.vue?vue&type=script&lang=js&"
export * from "./TurkeyDeveloped.vue?vue&type=script&lang=js&"
import style0 from "./TurkeyDeveloped.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports